import { z } from 'zod';
/**
 * Shared `includeDeleted` query flag for lookup endpoints that opt into
 * soft-deleted documents (resolving stale refs, detail pages of tombstones).
 *
 * String form on the wire — query params are never coerced; controllers
 * compare against 'true'.
 */ export const IncludeDeletedRequestSchema = z.object({
    includeDeleted: z.enum([
        'true',
        'false'
    ]).optional()
});

//# sourceMappingURL=include-deleted.schema.js.map